import React from 'react';
import { FaFacebookF, FaInstagram, FaPlus, FaTwitter } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function TeamMember({
  thumb,
  name,
  role,
  profileLink,
  fbUrl,
  twitterUrl,
  instaUrl,
}) {
  return (
    <div className="col-lg-3 col-sm-6">
      <div
        className="team-card bg-cover"
        style={{ backgroundImage: `url(${thumb})` }}
      >
        <div className="card-overlay" />
        <div className="card-left">
          <div className="member-info">
            <Link to={profileLink} className="name heading-2">
              {name}
            </Link>
            <span className="role body-text">{role}</span>
          </div>
        </div>
        <div className="card-right">
          <div className="card-socials">
            <ul className="social-items">
              <li className="social-item">
                <a href={instaUrl} className="social-link">
                  <span className="social-icon">
                    <FaInstagram />
                  </span>
                </a>
              </li>
              <li className="social-item">
                <a href={twitterUrl} className="social-link">
                  <span className="social-icon">
                    <FaTwitter />
                  </span>
                </a>
              </li>
              <li className="social-item">
                <a href={fbUrl} className="social-link">
                  <span className="social-icon">
                    <FaFacebookF />
                  </span>
                </a>
              </li>
            </ul>
            <div className="on-hover-icon">
              <FaPlus />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamMember;
